import Container from "react-bootstrap/Container";
import { Row, Col, Button } from "react-bootstrap";
import iconFB from "../../assets/ic_footer_fb.svg";
import iconInsta from "../../assets/ic_footer_insta.svg";
import iconYoutube from "../../assets/ic_footer_youtube.svg";
import { useState, useEffect } from "react";

import "./Footer.css";

function Footer() {
  const [currentYear, setCurrentYear] = useState(2025);

  useEffect(() => {
    var year = new Date().getFullYear();
    setCurrentYear(year);
  });

  var getYear = (currentYear) => {
    if (currentYear === 2025) {
      return "2025";
    } else {
      return `${"2025 - " + currentYear}`;
    }
  };

  return (
    <div>
      <section className="footer text-center text-lg-start" id="flooter">
        <Container>
          <div className="footer-content">
            <Row className="justify-content-center">
              <Col lg={4}>
                <div className="pt-5 mt-5">
                  <div className="footer-brand pb-2">CMC 16 BATCH</div>
                  <div className="footer-mail footer-link">
                    <a href="">cmc16batch1972@gmail.com</a>
                  </div>
                  {/* <div className="footer-phone footer-link">
                    <a href="">+91 98470 34068</a>
                  </div> */}
                </div>
              </Col>
              <Col lg={3}>
                <div className="pt-5 mt-5">
                  <div className="footer-title pb-2">Quick Links</div>
                  <div className="footer-link">
                    <a href="">Home</a>
                  </div>
                  <div className="footer-link">
                    <a href="#about">About</a>
                  </div>
                  <div className="footer-link">
                    <a href="#events">Events</a>
                  </div>
                  <div className="footer-link">
                    <a href="#president">President</a>
                  </div>
                  <div className="footer-link">
                    <a href="#gallery">Gallery</a>
                  </div>
                  <div className="footer-link">
                    <a href="">Members</a>
                  </div>
                  <div className="footer-link">
                    <a href="#memory">Loving Memory</a>
                  </div>
                  <div className="footer-link">
                    <a href="#blog">Blog</a>
                  </div>
                  <div className="footer-link">
                    <a href="#contact">Contact</a>
                  </div>
                </div>
              </Col>
              <Col lg={3}>
                <div className="pt-5 mt-5">
                  <div className="footer-title pb-2">Follow Us</div>
                  <div className="footer-social pt-3">
                    <div className="footer-icon-container">
                      <img src={iconFB} className="footer-icon" />
                    </div>

                    <div className="footer-link">
                      <a href="">Facebook</a>
                    </div>
                  </div>
                  <div className="footer-social pt-3">
                    <div className="footer-icon-container">
                      <img src={iconInsta} className="footer-icon" />
                    </div>
                    <div className="footer-link">
                      <a href="">Instagram</a>
                    </div>
                  </div>
                  <div className="footer-social pt-3">
                    <div className="footer-icon-container">
                      <img src={iconYoutube} className="footer-icon" />
                    </div>
                    <div className="footer-link">
                      <a href="">Youtube</a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <Container className="Footer-container">
        <div className="copyright">
          Copyright {getYear(currentYear)} All Rights Reserved <br />
          Website Designed & Developed By
          <a className="nthindex" href="http://www.nthindex.com/">
            Nthindex Software Solutions LLP
          </a>
        </div>
      </Container>
    </div>
  );
}
export default Footer;
